import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Tokens are namespaced per area so an admin, seller and buyer session can
// safely coexist in the same browser without overwriting each other.
const TOKEN_KEYS = { admin: "ds_token_admin", seller: "ds_token_seller", buyer: "ds_token_buyer", referor: "ds_token_referor" };

function areaRole() {
  const p = window.location.pathname;
  if (p.startsWith("/admin")) return "admin";
  if (p.startsWith("/seller")) return "seller";
  if (p.startsWith("/referor")) return "referor";
  return "buyer";
}

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function setToken(token, role) {
  const key = TOKEN_KEYS[role || areaRole()];
  if (token) localStorage.setItem(key, token);
  else localStorage.removeItem(key);
}

export function getToken(role) {
  return localStorage.getItem(TOKEN_KEYS[role || areaRole()]);
}

export function apiErr(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (d?.msg) return d.msg;
  return String(d);
}

// resolves an image ref that may be an external URL or a backend file path
export function mediaUrl(ref) {
  if (!ref) return "";
  if (ref.startsWith("http")) return ref;
  if (ref.startsWith("/api/")) return `${BACKEND_URL}${ref}`;
  return `${API}/files/${ref}`;
}

export const money = (n) =>
  "₹" + Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 });
